import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Marcas } from '../_model/marcas';
import { MarcasService } from '../_services/marcas.service';

@Component({
    selector: 'app-clock',
    templateUrl: './clock.component.html',
    styleUrls: ['./clock.component.less'],
    standalone: false
})
export class ClockComponent implements OnInit {

  constructor(private marca: MarcasService) { }

  marcasAlta: Marcas[] = [];
  marcasRel: Marcas[] = [];
  apiUrl: string = environment.apiUrl;
  showAll: boolean = false;

  ngOnInit() {
    this.marca.listPathOrder('alta').subscribe((data: any) => {
      data.forEach(el => {
        this.marcasAlta.push(new Marcas(el));
      });
    });
    this.marca.listPathOrder('relogio').subscribe((data: any) => {
      data.forEach(el => {
        this.marcasRel.push(new Marcas(el));
      });
    });
  }

  toogle() {
    this.showAll = !this.showAll;
  }
  link(item: Marcas):string {
    return item.link == '' ? "/produtos?query=&marca="+item.id+"&type="+item.tipo : (item.link.includes("http") ? item.link : "https://"+item.link);
  }
}
